import { useQuery } from '@tanstack/react-query';
import {
  fetchOperatorSummary,
  fetchOperatorMaterials,
  fetchOperatorTokens,
  fetchOperatorDowntime,
  fetchOperatorLive,
  fetchOperatorRoster
} from '../api/operatorDashboardApi';

export function useOperatorSummary() {
  return useQuery({
    queryKey: ['operator-dashboard', 'summary'],
    queryFn: fetchOperatorSummary,
    refetchInterval: 15000,
    staleTime: 10000
  });
}

export function useOperatorMaterials() {
  return useQuery({
    queryKey: ['operator-dashboard', 'materials'],
    queryFn: fetchOperatorMaterials,
    refetchInterval: 15000,
    staleTime: 10000
  });
}

export function useOperatorTokens(filters = {}) {
  return useQuery({
    queryKey: ['operator-dashboard', 'tokens', filters],
    queryFn: () => fetchOperatorTokens(filters),
    refetchInterval: 15000,
    staleTime: 10000,
    // the filter options come from the same payload, so keeping the previous
    // rows on screen stops the dropdowns emptying out between fetches
    keepPreviousData: true
  });
}

export function useOperatorLive() {
  return useQuery({
    queryKey: ['operator-dashboard', 'live'],
    queryFn: fetchOperatorLive,
    // The monitor is a live view; the WebSocket carries speed and status, this
    // carries who is on what, which changes on a human timescale.
    refetchInterval: 5000,
    staleTime: 2000
  });
}

export function useOperatorRoster() {
  return useQuery({
    queryKey: ['operator-roster'],
    queryFn: fetchOperatorRoster,
    staleTime: 5 * 60 * 1000,
    retry: 1
  });
}

export function useOperatorDowntime(days = 30) {
  return useQuery({
    queryKey: ['operator-dashboard', 'downtime', days],
    queryFn: () => fetchOperatorDowntime(days),
    refetchInterval: 60000,
    staleTime: 30000
  });
}
